<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="chap11">Book Two</h1>
<h1 class="center"><i>The House of Sholto and Sons</i></h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 16-chap11.vue?2e4b4b10